<template>
    <div>
        <template v-for="(note, idx) in notes">
            <DocNote v-if="!note.isDeleted" :key="idx" :idx="idx" :note="note" :disabled="disabledDocument"/>
        </template>
        <div v-if="isTouchedForm && validateDocumentNotes && !hasAtLeastOneNonEmptyNote" class="text-danger">
            Please add at least one non-blank note.
        </div>
        <button @click="addNote"
                class="btn btn-sm border rounded clickable px-3 mr-2 mt-2">
            Add note
        </button>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {DOC_NOTE_ADD} from '@/store/modules/doc-viewer'
import {DOC_METADATA_BUILD_ERRORS_LIST} from '@/store/modules/doc-viewer/metadata'
import DocNote from '../parts/DocNote'

export default {
    name: 'DocumentViewerNotes',
    components: {DocNote},
    computed: {
        ...mapGetters('doc_viewer', [
            'notes',
            'hasAtLeastOneNonEmptyNote',
            'disabledDocument'
        ]),

        ...mapGetters('doc_viewer_settings', [
            'validateDocumentNotes'
        ]),

        ...mapGetters('doc_viewer_metadata', [
            'isTouchedForm'
        ])
    },
    methods: {
        ...mapMutations('doc_viewer', {
            addNote: DOC_NOTE_ADD
        }),

        ...mapActions('doc_viewer_metadata', {
            buildDocErrorsList: DOC_METADATA_BUILD_ERRORS_LIST
        })
    },
    watch: {
        notes: {
            handler() {
                if (this.isTouchedForm && this.validateDocumentNotes) {
                    this.buildDocErrorsList()
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
